import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button, capitalize, Typography, Tooltip } from '@mui/material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { CenteredFlexBox, ColumnFlexBox } from '../../../Components/FlexBox';
import ReportSelect from '../../../Components/Inputs/ReportSelect';
import FiltersNavbarWrapper from '../../../Components/Filters/FiltersNavbarWrapper';
import Fab from '../../../Components/Navbar/Fab';
import ThemeFab from '../../../Components/Button/ThemeFab';
import {
  culture,
  formatPayloadDate,
  getMonthRange,
  getThisMonthRange,
} from '../../../Helpers/dates';
import ExcelIcon from '../../../Components/Logos/Excel';
import { download } from '../../../api/utils';
import useAPI from '../../../api';

const useStyles = () => ({
  root: {
    padding: '16px',
  },
  form: {
    display: 'flex',
    justifyContent: 'center',
  },
  gridItem: {
    padding: '16px 16px 0px 0px',
  },
  selectLabel: {
    borderRight: '1px solid',
    borderColor: (theme) => theme.palette.divider,
  },
  btnDiv: {
    width: '10%',
    display: 'flex',
    alignItems: 'flex-end',
  },
});

const getLastYearMonths = () => {
  const months = [];
  const currentDate = new Date();
  for (let i = 1; i < 12; i++) {
    const month = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1 // Set to the first day of the month
    );
    months.push({
      label: capitalize(
        month.toLocaleString(culture, {
          month: 'long',
          year: 'numeric',
        })
      ),
      value: month.getMonth() + 1,
      active: true,
    });
  }
  return months;
};

const payloadPeriod = function payloadPeriod(per = 'month') {
  let returnRange = [];
  if (typeof per === 'number') {
    returnRange = getMonthRange(per);
  } else if (per === 'month') {
    returnRange = getThisMonthRange();
  }

  return returnRange;
};

const FiltersNavbar = function FiltersNavbar({
  currentFilters,
  toggle,
  open,
  switchLabel,
  onSwitchClick,
  switchValue,
  setCurrentFilters,
  isRolling,
  hideExport2Excel,
  isOperator,
}) {
  const intl = useIntl();
  const API = useAPI();
  const classes = useStyles();

  const [period, setPeriod] = useState(currentFilters?.periodName || 'month');

  const downloadRedemptionFile = useCallback(() => {
    const [start, end] = payloadPeriod(period);
    return download(
      `redemption-${typeof period === 'number' ? `month-${period}` : period}.xlsx`,
      API.exportRedemption2Excel(
        formatPayloadDate(start).toISOString(),
        formatPayloadDate(end).toISOString()
      )
    );
  }, [period]);

  const downloadRollingRedemptionFile = useCallback(() => {
    return download(
      `rolling-redemption.xlsx`,
      API.exportRollingRedemption2Excel(
        formatPayloadDate(new Date()).toISOString()
      )
    );
  }, [period]);

  return (
    <FiltersNavbarWrapper
      currentFilters={currentFilters}
      open={open}
      onToggle={toggle}
      switchLabel={switchLabel}
      onSwitchClick={onSwitchClick}
      switchValue={switchValue}
      isOperator={isOperator}
      setCurrentFilters={setCurrentFilters}
      title={`${intl.messages.REDEMPTION} ${isRolling ? intl.messages.ROLLINGREDEMPTIONREPORT : intl.messages.REDEMPTIONREPORT}`}
    >
      <CenteredFlexBox gap="16px" paddingTop="16px" height="100%">
        {!isRolling && (
          <ReportSelect
            defaultValue="month"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            classes={classes}
            fullWidth
            size="small"
            height="30px"
            padding="20px"
            label={intl.messages.PERIOD}
            items={[
              {
                label: intl.messages.CURRENT_MONTH,
                value: 'month',
                active: true,
              },
              ...getLastYearMonths(),
            ]}
          />
        )}

        {!hideExport2Excel && (
          <Tooltip title={intl.messages.EXPORT_EXCEL}>
            <Button
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                padding: '6px 8px',
                gap: '8px',
                fontSize: '13px',
                whiteSpace: 'nowrap',
                width: !isRolling ? '240px' : '170px',
              }}
              variant="outlined"
              onClick={
                isRolling
                  ? downloadRollingRedemptionFile
                  : downloadRedemptionFile
              }
              color="success"
            >
              {intl.messages.EXPORT_EXCEL}
              <ExcelIcon />
            </Button>
          </Tooltip>
        )}
        {!isRolling && (
          <Button
            id="search-redemption-report-btn"
            fullWidth
            sx={{
              margin: '0 auto',
              display: 'block',
              textTransform: 'none',
              width: '160px',
            }}
            onClick={() => {
              setCurrentFilters({
                periodName: period,
              });
            }}
          >
            {intl.messages.SEARCH}
          </Button>
        )}
      </CenteredFlexBox>
    </FiltersNavbarWrapper>
  );
};
export default FiltersNavbar;
